import { render } from "./brokerageRule.vue?vue&type=template&id=240379f5&scoped=true"
import script from "./brokerageRule.vue?vue&type=script&lang=js"
export * from "./brokerageRule.vue?vue&type=script&lang=js"

import "./brokerageRule.vue?vue&type=style&index=0&id=240379f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240379f5"]])

export default __exports__